import { useSelector, shallowEqual } from 'react-redux';
import { useJourneyData } from 'hooks/useJourneyData';
import { selectDetails } from 'state/email-quote/email-quote-slice';
import { routePath } from 'config/route-config';
import { useElecMultirate } from 'hooks/useElecMultirate';

import { TProduct } from 'api/models/TProduct';

const { VITE_PATH_PREFIX = '' } = process.env;

export const useEmailQuotePayload = (product: TProduct = {}) => {
  const { firstName, lastName, email } = useSelector(
    selectDetails,
    shallowEqual
  );
  const { showE7Tariffs, showTOUTariffs } = useElecMultirate();
  const { electricityTil, gasTil } = product;
  const {
    consumption,
    address,
    mpan,
    mprn,
    paymentMethod,
    meterType,
    fuelTypeString
  } = useJourneyData();
  const tariffType =
    (electricityTil || {}).tariffType || (gasTil || {}).tariffType;
  const returnURL = `${window.location.origin
    }${VITE_PATH_PREFIX}${routePath.retrieveQuote.replace('/:quoteId', '')}`;

  return {
    journeyURL: returnURL,
    ...(consumption.electric && {
      electricityConsumption: consumption.electric
    }),
    ...(consumption.gas && { gasConsumption: consumption.gas }),
    ...(mpan && { MPAN: mpan }),
    ...(mprn && { MPRN: mprn }),
    postCode: address.postcode,
    meterType,
    isTOU: showTOUTariffs,
    isEconomy7: showE7Tariffs,
    fuel: fuelTypeString,
    paymentOption: paymentMethod,
    tariffType,
    currentAddress: {
      ...address,
      postCode: address.postcode,
      udprn: Number(address.udprn)
    },
    customerDetails: {
      firstName,
      lastName,
      emailAddress: email
    }
  };
};
